export default "__VITE_ASSET__FPlH_vDG__"